import type { ComponentType } from 'react'

import type { DataBenchScoreActionProps, YeshumanPluginApi } from '@yeshuman/sdk'

/** Re-export platform Score-row action props for pack components. */
export type { DataBenchScoreActionProps }

/** Register a Score-row action via the product-contract 2.3.0 Data Bench slot. */
export function registerDataBenchScoreActions(
  app: YeshumanPluginApi,
  component: ComponentType<DataBenchScoreActionProps>,
): void {
  app.dataBench.scoreAction(component)
}
